import { globalEventBus } from '@fiverr-private/futile';
import { EVENT_NAME, START_SESSION_RECORDING_EVENT, STOP_SESSION_RECORDING_EVENT, PAGE_VIEW } from '../helpers/constants';

/**
 * Sends an event to the mixpanel key on the global event bus.
 * @param {String} eventName  The event's name.
 * @param {Object} properties The event's properties.
 *
 * @example
 *
 * mixpanel.track('Eventful Event', {
 *   'Property': value
 * });
 */
export const track = (eventName, properties) => {
    if (!eventName || typeof eventName !== 'string') {
        throw new Error('The "eventName" argument must be provided to mixpanel.track');
    }

    globalEventBus.deferred(EVENT_NAME, eventName, properties);
};

/**
 * Sends a page view event to the mixpanel key on the global event bus.
 * @param {Object} properties The event's properties.
 *
 * @example
 *
 * mixpanel.trackPageView({
 *   'Property': value
 * });
 */
export const trackPageView = (properties) => {
    track(PAGE_VIEW, properties);
};

/**
 *  Starts Mixpanel session recording
 */
export const startSessionRecording = () => {
    globalEventBus.emit(START_SESSION_RECORDING_EVENT);
};

/**
 *  Stops Mixpanel session recording
 */
export const stopSessionRecording = () => {
    globalEventBus.emit(STOP_SESSION_RECORDING_EVENT);
};
